import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';


document.addEventListener("DOMContentLoaded", function () {

    const servicesList = new Swiper('.services__list', {
        modules: [Navigation, Pagination],
        loop: true,
        slidesPerView: 2,
        spaceBetween: 20,
        navigation: {
            nextEl: '.swiper__next',
            prevEl: '.swiper__prev',
        },
        breakpoints: {
            1366: {
                slidesPerView: 5,
            },
            1023: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 3,
            }
        }
    });

    const servicesEquipmentList = new Swiper('.services-equipment__list', {
        modules: [Navigation, Pagination],
        loop: true,
        slidesPerView: 2,
        spaceBetween: 20,
        navigation: {
            nextEl: '.swiper__next',
            prevEl: '.swiper__prev',
        },
        breakpoints: {
            1366: {
                slidesPerView: 5,
            },
            1023: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 3,
            }
        }
    });


    const otherEquipmentList = new Swiper('.other-equipment__list', {
        modules: [Navigation, Pagination],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            nextEl: '.swiper__next',
            prevEl: '.swiper__prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
        }
    });

    const videoContent = new Swiper('.video__content', {
        modules: [Navigation, Pagination],
        loop: true,
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

    const serviceGalleriesList = new Swiper('.service-gallery__list', {
        modules: [Navigation, Pagination],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            nextEl: '.swiper__next',
            prevEl: '.swiper__prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
            },
            568: {
                slidesPerView: 2,
            }
        }
    });

    const servicesGalleriesListTop = new Swiper('.services-galleries__list--top', {
        modules: [Navigation, Pagination],
        loop: true,
        centerInsufficientSlides: true,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            nextEl: '.swiper__next--top',
            prevEl: '.swiper__prev--top',
        },
        breakpoints: {
            1023: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 3,
            },
            568: {
                slidesPerView: 2,
            }
        }
    });

    const servicesGalleriesList = new Swiper('.services-galleries__list', {
        modules: [Navigation, Pagination],
        loop: true,
        centerInsufficientSlides: true,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            nextEl: '.swiper__next',
            prevEl: '.swiper__prev',
        },
        breakpoints: {
            1023: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 3,
            },
            568: {
                slidesPerView: 2,
            }
        }
    });

    const servicesLeadsList = new Swiper('.services-leads__list', {
        modules: [Navigation, Pagination],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            nextEl: '.swiper__next',
            prevEl: '.swiper__prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
        }
    });

    const aboutUsLeadsList = new Swiper('.about-us-leads__list', {
        modules: [Navigation, Pagination],
        loop: true,
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });


    const specialiastDiplomsList = new Swiper('.specialiast-diploms__list', {
        modules: [Navigation, Pagination],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            nextEl: '.swiper__next',
            prevEl: '.swiper__prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 5,
        },
        breakpoints: {
            1439: {
                slidesPerView: 4,
            },
            1024: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 2,
            }
        }
    });

    const morpheus8 = new Swiper('.morpheus8-gallery-swiper', {
        modules: [Navigation, Pagination],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 16,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 2,
            },
        },
        lazy: {
            loadPrevNext: true,
        },
    });

    const reviews = new Swiper('.morpheus8-reviews-swiper', {
        modules: [Navigation, Pagination],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 16,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 2,
            },
        },
        lazy: {
            loadPrevNext: true,
        },
    });

});
